"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Select = exports.getSelectChildren = void 0;
var react_1 = __importStar(require("react"));
var select_1 = require("@react-aria/select");
var collections_1 = require("@react-stately/collections");
var select_2 = require("@react-stately/select");
var classnames_1 = __importDefault(require("classnames"));
var uuid_1 = require("uuid");
var draft_form_1 = require("@kaizen/draft-form");
var ListBox_1 = require("./components/ListBox");
var ListBoxSection_1 = require("./components/ListBoxSection");
var Option_1 = require("./components/Option");
var Overlay_1 = require("./components/Overlay");
var TriggerButton_1 = require("./components/TriggerButton");
var SelectContext_1 = require("./context/SelectContext");
var Select_module_scss_1 = __importDefault(require("./Select.module.scss"));
var getSelectChildren = function (item) {
    return Array.isArray(item.value) ? (react_1["default"].createElement(collections_1.Section, { key: item.label, title: item.label, items: item.value }, function (child) { return react_1["default"].createElement(collections_1.Item, { key: child.value }, child.label); })) : (react_1["default"].createElement(collections_1.Item, { key: item.value }, item.label));
};
exports.getSelectChildren = getSelectChildren;
var Select = function (_a) {
    var propsId = _a.id, label = _a.label, description = _a.description, isFullWidth = _a.isFullWidth, placeholder = _a.placeholder, isDisabled = _a.isDisabled, _b = _a.isReversed, isReversed = _b === void 0 ? false : _b, disabledValues = _a.disabledValues, status = _a.status, defaultOpen = _a.defaultOpen, validationMessage = _a.validationMessage, classNameOverride = _a.classNameOverride, _c = _a.trigger, trigger = _c === void 0 ? function (triggerProps) { return (react_1["default"].createElement(TriggerButton_1.TriggerButton, __assign({}, triggerProps, { ref: buttonRef }))); } : _c, children = _a.children, restProps = __rest(_a, ["id", "label", "description", "isFullWidth", "placeholder", "isDisabled", "isReversed", "disabledValues", "status", "defaultOpen", "validationMessage", "classNameOverride", "trigger", "children"]);
    var id = (0, react_1.useState)(propsId || (0, uuid_1.v4)())[0];
    var descriptionId = "".concat(id, "-field-message");
    var buttonRef = react_1["default"].useRef(null);
    var invalidStatus = status === "error" ? "invalid" : "valid";
    var listBoxID = (0, react_1.useState)((0, uuid_1.v4)())[0];
    var ariaSelectProps = __assign({ label: label, description: description, placeholder: placeholder, isDisabled: isDisabled, defaultOpen: defaultOpen, validationState: invalidStatus, errorMessage: validationMessage, disabledKeys: disabledValues, children: exports.getSelectChildren }, restProps);
    var state = (0, select_2.useSelectState)(ariaSelectProps);
    var renderChildren = children
        ? children
        : function (_a) {
            var items = _a.items;
            return (react_1["default"].createElement(react_1["default"].Fragment, null, items.map(function (item) {
                return item.type === "section" ? (react_1["default"].createElement(ListBoxSection_1.ListBoxSection, { key: item.key, section: item })) : (react_1["default"].createElement(Option_1.Option, { key: item.key, item: item }));
            })));
        };
    var _d = (0, select_1.useSelect)(__assign(__assign({}, ariaSelectProps), { "aria-describedby": descriptionId }), state, buttonRef), labelProps = _d.labelProps, triggerProps = _d.triggerProps, valueProps = _d.valueProps, menuProps = _d.menuProps, errorMessageProps = _d.errorMessageProps, descriptionProps = _d.descriptionProps;
    var items = Array.from(state.collection);
    // Fix the issue when default open and close by keyboard, then focus is lost
    (0, react_1.useEffect)(function () {
        var _a;
        if (state.isOpen === false && defaultOpen) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [state.isOpen]);
    return (react_1["default"].createElement(SelectContext_1.SelectContext.Provider, { value: {
            state: state
        } },
        react_1["default"].createElement("div", { className: (0, classnames_1["default"])(!isFullWidth && Select_module_scss_1["default"].notFullWidth, classNameOverride) },
            react_1["default"].createElement(draft_form_1.Label, __assign({}, labelProps, { reversed: isReversed, disabled: isDisabled }), label),
            react_1["default"].createElement(select_1.HiddenSelect, { label: label, name: id, state: state, triggerRef: buttonRef }),
            react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Select_module_scss_1["default"].container) },
                react_1["default"].cloneElement(trigger({
                    placeholder: placeholder,
                    triggerProps: triggerProps,
                    valueProps: valueProps,
                    status: status,
                    isReversed: isReversed,
                    "aria-controls": state.isOpen ? listBoxID : undefined
                }, buttonRef), { ref: buttonRef }),
                state.isOpen && (react_1["default"].createElement(Overlay_1.Overlay, { triggerRef: buttonRef },
                    react_1["default"].createElement(ListBox_1.ListBox, { menuProps: menuProps, id: listBoxID }, renderChildren({ items: items }))))),
            validationMessage && (react_1["default"].createElement(draft_form_1.FieldMessage, __assign({}, errorMessageProps, { message: validationMessage, status: status, reversed: isReversed }))),
            description && (react_1["default"].createElement(draft_form_1.FieldMessage, __assign({}, descriptionProps, { id: descriptionId, message: description, reversed: isReversed }))))));
};
exports.Select = Select;
exports.Select.TriggerButton = TriggerButton_1.TriggerButton;
exports.Select.ListBox = ListBox_1.ListBox;
exports.Select.Option = Option_1.Option;
exports.Select.displayName = "Select";
//# sourceMappingURL=Select.js.map